// Página de inicio según el rol: el vendedor entra a sus préstamos (puede abrir
// Sensores y Mis cultivos para ver los equipos que tiene prestados)
export const homePath = (user) => {
    const authorities = (user && user.authorities) || [];
    if (authorities.includes('ROLE_SELLER')) {
        return '/loans';
    }
    return '/sensors';
};

// Sin permiso para listar sensores, la vista de sensores no tiene nada que mostrar
export const canListSensors = (user) => !!(user && user.authorities && user.authorities.includes('GET_SENSORS_FROM'));
